import Step3 from './Step3';

export default {
  title: 'Physical Conditions',
  component: Step3,
};
